import { render } from "./HostAccountStatement.vue?vue&type=template&id=124c0cc8"
import script from "./HostAccountStatement.vue?vue&type=script&lang=js"
export * from "./HostAccountStatement.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__